import React, { FunctionComponent } from 'react'
import { Field } from 'redux-form'
import SelectField from './selectField'

interface User {
  id: string
  firstName?: string
  lastName?: string
  name?: string
  email?: string
}

interface Props {
  label: string
  name: string
  defaultOption?: string
  users?: User[]
  isLoading?: boolean
}

export const UserSelect: FunctionComponent<Props> = ({
  label,
  name,
  defaultOption = 'Select a user',
  users = [],
  isLoading = false,
}) => {
  const sortedUsers = [...users].sort((a, b) => {
    const nameA = a.firstName && a.lastName
      ? `${a.firstName} ${a.lastName}`
      : a.name || ''
    const nameB = b.firstName && b.lastName
      ? `${b.firstName} ${b.lastName}`
      : b.name || ''
    return nameA.localeCompare(nameB)
  })

  const renderOptions = (usersList: User[]) =>
    usersList.map((user) => {
      const fullName = user.firstName && user.lastName
        ? `${user.firstName} ${user.lastName}`
        : user.name || 'Unknown'
      const displayLabel = user.email
        ? `${user.id} - ${fullName} (${user.email})`
        : `${user.id} - ${fullName}`

      return (
        <option key={user.id} value={user.id}>
          {displayLabel}
        </option>
      )
    })

  return (
    <Field label={label} name={name} component={SelectField} disabled={isLoading}>
      <option value="">{defaultOption}</option>
      {sortedUsers.length > 0 && renderOptions(sortedUsers)}
      {sortedUsers.length === 0 && !isLoading && (
        <option disabled>No users available</option>
      )}
      {isLoading && <option disabled>Loading users...</option>}
    </Field>
  )
}

UserSelect.displayName = 'UserSelect'
